import axios from '@lib/axios';

const handleError = e => {
    console.error(e.message);
};

/**
 * 获取视频信息
 * @param {String} itemId 视频id
 */
export async function getItemInfo({itemId, st}) {
    try {
        const { data } = await this.$http.get(`/hey-server/api/v1/share/video?itemId=${itemId}&st=${st}`);
        return data;
    } catch (e) {
        handleError(e);
    }
}

/**
 * 获取评论
 * @param {String} itemId 视频id
 */
// export async function getItemComment(itemId) {
//     try {
//         const { data } = await this.$http.get(`/hey-comment-server/api/v1/comments?itemId=${itemId}&type=0&cursor=`).then(data => data.data);
//         return data;
//     } catch (e) {
//         handleError(e);
//     }
// }
export async function getItemComment(params) {
    const {data} = await axios.get(`/hey-comment-server/api/v1/comments`, { params: {
        type: 0,
        cursor: '',
        ...params,
    } });
    return data;
}

/**
 * 获取弹幕
 * @param {String} itemId 视频id
 */

export async function getVideoBarrage(itemId) {
    try {
        const { data } = await this.$http.get(`/hey-comment-server/api/v1/comments?itemId=${itemId}&type=1&cursor=`).then(data => data.data);
        return data;
    } catch (e) {
        handleError(e);
    }
}

/**
 * 获取被 pick 的弹幕
 * @param {String} itemId 视频id
 */

export async function getPickedBarrage(itemId) {
    try {
        const data = await this.$http.get(`/hey-comment-server/api/v1/danmu/poll?app=highsheng&itemId=${itemId}`).then(data => data.data.data.danmuInfos);
        return data;
    } catch (e) {
        handleError(e);
    }
}

/**
 * 获取用户
 * @param {String} targetUserId 用户id
 */
export async function getUserInfo(targetUserId) {
    try {
        const { data } = await this.$http.get(`/hey-server/api/v1/share/user?targetUserId=${targetUserId}`);
        // const { data } = await this.$http({
        //     method: 'GET',
        //     url: `/hey-server/api/v1/share/user`,
        //     params: {
        //         targetUserId,
        //         app: 'highsheng',
        //     }
        // });
        return data;
    } catch (e) {
        handleError(e);
    }
}

export async function getRecoReason(authorId) {
    const {data} = await this.$http.get(`/hey-server/api/v1/share/recoReason?authorId=${authorId}`);
    return data;
}

/**
 * 获取房间分享信息
 * @param {String} roomId 房间ID
 * @param {String} fromId 分享人ID
 */
export async function getRoomInfo(params) {
    try {
        const { data } = await axios.get(`/hey-server/api/v3/room/room/share/roomInfo`, { params });
        return data;
    } catch (e) {
        handleError(e);
    }
}

/**
 * 获取天团信息
 * @param {String} bandId 天团ID
 */

export async function getGroupInfo({bandId}) {
    const {data} = await axios.get(`/hey-server/api/v1/share/band?bandId=${bandId}`);
    return data;
}

/**
 * 获取天团广场-正在招募的团
 */
 export async function getOpenGroupList({cursor}) {
    const {data} = await axios.get(`/hey-server/api/v3/band/recruitingBands?cursor=${cursor}`);
    return data;
}

/**
 * 获取天团广场-热门的团
 */
 export async function getHotGroupList({cursor}) {
    const {data} = await axios.get(`/hey-server/api/v3/band/hotBands?cursor=${cursor}`);
    return data;
}

/**
 * 获取签约报表-日报
 */
 export async function getContractDayShareReport(params) {
    const {data} = await axios.get(`/hey-server/api/v3/room/contract/report/day/internal`, { params });
    return data;
}

/**
 * 获取签约报表-周报
 */
 export async function getContractWeekShareReport(params) {
    const {data} = await axios.get(`/hey-server/api/v3/room/contract/report/week/internal`, { params });
    return data;
}

/**
 * 获取裂变活动分享信息
 */
 export async function getDiamondInviteShareInfo(params) {
    const {data} = await axios.get(`/hey-server/api/v2/cronus/share/info`, { params });
    return data;
}

/**
 * 校园相关
 */
// 获取学校详情
export async function getSchoolInfo(params) {
    const {data} = await axios.get(`/hey-server/api/v1/school/getInfo`, { params });
    return data;
}
// 获取学校最热feed
export async function getSchoolHotFeed(params) {
    const {data} = await axios.get(`/hey-server/api/v1/school/feed/hot`, { params });
    return data;
}

/**
 * 音色测试
 */
// 获取音色测试结果
export async function getTimbreTestResult(params) {
    const {data} = await axios.get(`/hey-server/api/v1/voice/eval/report`, { params });
    return data;
}

/**
 * 哄哄相关
 */
// 获取广场信息
export async function getHongInfo(params) {
    const {data} = await axios.get(`/hey-server/api/v1/chatGame/getPage`, { params });
    return data;
}
// 获取话题列表
export async function getHongTopic(params) {
    const {data} = await axios.get(`/hey-server/api/v1/chatGame/getTopicList`, { params });
    return data;
}

/**
 * 流浪猫
 */
// 获取邀请信息
export async function get2025CatRescueInviteInfo(params) {
    const {data} = await axios.get(`/imv-activity-server/api/v1/catRescue/inviteInfo`, { params });
    return data;
}
